/*
 * @Author: wuzijia wuzijia1230@qq.com
 * @Date: 2023-10-17 15:58:16
 * @LastEditors: wuzijia wuzijia1230@qq.com
 * @LastEditTime: 2023-10-18 10:55:00
 * @FilePath: \youxi\src\util\customerShunt.js
 * @Description: 立即购买、咨询客服分流规则
 */

import { getAllotGroupCode } from "@/request/API";
import { Message } from "element-ui";

/**
 * @description: 
 * @param {*} product_id 账号id
 * @param {*} game_id 游戏id
 * @param {*} type 1 账号 2装备
 * @param {*} callback
 * @return {*} game_buy_status：当前游戏是否开启在线支付true false
 * @return {*} allot_group_buy_status：当前账号是否符合配置规则，在线支付配置状态 true false
 * @return {*} group_code：客服分组标识
 */
const getBuyOrGroupCode = (product_id, game_id, type, callback = (e) => {}) => {
  getAllotGroupCode({
    product_id,
    game_id,
    type
  }).then(res => {
    callback(res.data)
  }).catch(err => {
    Message({
      type: "info",
      center: true,
      message: '网络有点小问题，请稍等一会再试'
    })
  })
}

export default {
  getBuyOrGroupCode
}